@if (visible) {
<div class="review-overlay" [ngClass]="currentTheme">
  <div class="review-modal">
    <div class="modal-header">
      <h4 class="modal-title">Review Diagnostics</h4>
      <div class="header-actions">
        <i class="fa fa-times hoverable" (click)="dismiss()" aria-label="Close" title="Close"></i>
      </div>
    </div>
    <div class="modal-body">
      @if (!ignored && !showBulkMessage && dataLoaded) {
<label>
        Please resolve the diagnostics below by clicking
        <a role="button" href="#" (click)="goToDiagnostics($event)">here</a>
        before doing a client review
      </label>
}
      @if (!ignored && showBulkMessage && dataLoaded) {
<label>
        One or more submission has open diagnostics. Please resolve the diagnostics by clicking
        <a role="button" href="#" (click)="goToDiagnostics($event)">here</a>
        before doing a client review
      </label>
}

      <gtw-pdf-review-diagnostics-ce
        #ceHost
        [attr.params]="paramsJson"
        review-diag-events>
      </gtw-pdf-review-diagnostics-ce>
    </div>
  </div>
</div>
}
